import styled, { css, FlattenSimpleInterpolation } from "styled-components";

// Based on https://www.joshwcomeau.com/react/modern-spacer-gif/
type SpacerAxis = "horizontal" | "vertical";
type SpacerSize = keyof typeof spacing;
type SpacerHelperProps = {
  axis?: SpacerAxis;
  size?: SpacerSize;
};
const getSpacerCSS = ({
  axis,
  size = "xsmall",
}: SpacerHelperProps): FlattenSimpleInterpolation => {
  const width = axis === "vertical" ? "1px" : spacing[size];
  const height = axis === "horizontal" ? "1px" : spacing[size];
  return css`
    width: ${width};
    min-width: ${width};
    height: ${height};
    min-height: ${height};
  `;
};
type SpacerProps = {
  axis?: SpacerAxis;
  size?: SpacerSize;
  phone?: SpacerSize;
  tablet?: SpacerSize;
  desktopSmall?: SpacerSize;
  desktop?: SpacerSize;
};

export const Spacer = styled.span<SpacerProps>`
  display: block;
  ${getSpacerCSS}
  ${(p) =>
    p.phone &&
    css`
      @media screen and (min-width: ${breakpoint.phone}) {
        ${getSpacerCSS({ axis: p.axis, size: p.phone })}
      }
    `}
  ${(p) =>
    p.tablet &&
    css`
      @media screen and (min-width: ${breakpoint.tablet}) {
        ${getSpacerCSS({ axis: p.axis, size: p.tablet })}
      }
    `}
  ${(p) =>
    p.desktopSmall &&
    css`
      @media screen and (min-width: ${breakpoint.desktop_small}) {
        ${getSpacerCSS({ axis: p.axis, size: p.desktopSmall })}
      }
    `}
  ${(p) =>
    p.desktop &&
    css`
      @media screen and (min-width: ${breakpoint.desktop}) {
        ${getSpacerCSS({ axis: p.axis, size: p.desktop })}
      }
    `}
`;
export const breakpoint = {
  phone: "600px",
  tablet: "834px",
  desktop_small: "1024px",
  desktop: "1440px",
} as const;

export const spacing = {
  none: "0",
  xxxsmall: "0.25rem",
  xxsmall: "0.5rem",
  xsmall: "1rem",
  small: "1.5rem",
  medium: "2rem",
  large: "2.5rem",
  xlarge: "3rem",
  xxlarge: "4rem",
  xxxlarge: "5rem",
  xxxxlarge: "6rem",
} as const;
